import { InfoIcon as PhosphorInfoIcon, type IconProps } from "@phosphor-icons/react";

export function InfoIcon(props: IconProps) {
  return <PhosphorInfoIcon size={24} weight="regular" {...props} />;
}
